
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/useAuth';

interface Category {
  id: string;
  name: string;
  description?: string;
  is_default: boolean;
}

interface Trade {
  id: string;
  name: string;
  description?: string;
  is_default: boolean;
}

export const useSupplierCategories = () => {
  const { profile } = useAuth();

  const { data: categories = [], isLoading: categoriesLoading } = useQuery({
    queryKey: ['supplier-categories', profile?.company_id],
    queryFn: async () => {
      if (!profile?.company_id) return [];
      
      const { data, error } = await supabase.rpc('get_all_categories', {
        user_company_id: profile.company_id
      });

      if (error) throw error;
      return data as Category[];
    },
    enabled: !!profile?.company_id,
  });

  const { data: trades = [], isLoading: tradesLoading } = useQuery({
    queryKey: ['supplier-trades', profile?.company_id],
    queryFn: async () => {
      if (!profile?.company_id) return [];
      
      const { data, error } = await supabase.rpc('get_all_trades', {
        user_company_id: profile.company_id
      });

      if (error) throw error;
      return data as Trade[];
    },
    enabled: !!profile?.company_id,
  });

  return {
    categories,
    trades,
    isLoading: categoriesLoading || tradesLoading
  };
};
